import { connect } from "react-redux";
import { Breadcrumbs } from "@authzsvc/common-react-components";
import { selectBreadcrumbs } from "../../selectors";

export default connect((state) => ({
  nav: selectBreadcrumbs(state),
}))(Breadcrumbs);
